/**
 * De onde veio uma cortesia `plan: "creator_comp"` — decide copy na faixa da
 * `/pro` e no aviso de fim do PRO.
 *
 * O discriminador já existe no dado: `redeemCreatorCode` NUNCA grava
 * `grantReason`; só `buildProCompGrantPatch` (concessão do admin e cupom)
 * grava. Então `grantReason` ausente = Livra Creators, a única situação em que
 * "creator" é verdade. `promo:*` é cupom (ex.: BIENAL15); qualquer outro
 * motivo é concessão da casa pelo painel.
 *
 * Nunca uma prop "é promo?" ao lado — duplicaria a mesma pergunta em dois
 * lugares (a doença do BUG-81).
 */
export type CompOrigin = "creator" | "promo" | "granted";

export function resolveCompOrigin(grantReason: string | null | undefined): CompOrigin {
  if (typeof grantReason !== "string" || grantReason === "") return "creator";
  return grantReason.startsWith("promo:") ? "promo" : "granted";
}
